// extracted by mini-css-extract-plugin
export var formContainer = "_c8-0";
export var message = "_c8-1";